


































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { ResidentModule } from '@/store/modules/resident.module'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import CreditCard from '@/components/CreditCard.vue'
import eCheckCard from '@/components/eCheckCard.vue'
import { EPaymentMethodType, IResidentPaymentMethod, ISchedulePaymentItem } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import ScrollView from '@/components/ScrollView.vue'

@Component({
  components: {
    ScrollView,
    LoaderWrapper,
    eCheckCard,
    CreditCard,
    Modal
  },
  props: {
    selected: {
      type: Number,
      default: () => {
        return 0
      }
    }
  }
})
export default class EditPaymentModal extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  selectedCard: number = this.$props.selected
  isLoading: boolean = false

  get scheduleItemId () {
    return this.$route.params.scheduleItemId
  }

  get scheduleItems () {
    return this.$store.state.payments.autoPayItems
  }

  get selectedScheduleItem () {
    return this.scheduleItems.find((item: ISchedulePaymentItem) => item.id.toString() === this.scheduleItemId.toString())
  }

  get paymentMethods () {
    return this.$store.state.resident.paymentMethods
  }

  get ccPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => paymentMethod.type === EPaymentMethodType.CREDIT_CARD)
  }

  get echeckPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => paymentMethod.type === EPaymentMethodType.ECHECK)
  }

  async mounted () {
    this.isLoading = true
    await this.residentModuleInstance.getResidentPaymentMethods(this.selectedScheduleItem.setting.resident.id)
    this.isLoading = false
  }

  selectPaymentMethod (paymentMethod: IResidentPaymentMethod) {
    this.selectedCard = paymentMethod.id
  }

  emitSelected () {
    this.$emit('select', this.paymentMethods.find((paymentMethod: IResidentPaymentMethod) => (
      paymentMethod.id === this.selectedCard
    )))
  }
}
